import React, { useContext } from 'react'
import { NavLink } from 'react-router'
import Navigation from '@App/navigation'
import { ICONS } from '@Const/common'
import { StoresContext } from '@App/contexts'
import ExpandableItem from '../../Sidebar/ExpandableItem'

const MatchingToolSubNavigation = () => {
    const { rightsholderStore, userStore } = useContext(StoresContext)
    const currentRightsholderId = rightsholderStore.currentRightsholderId

    return (
        <>
            {(!rightsholderStore.isRestricted || userStore.isInternal) && (
                <ExpandableItem heading="Matching" icon={ICONS.linkIcon}>
                    <NavLink to={Navigation.rightholder.matchClaim.match(currentRightsholderId)}>Matching Tool</NavLink>
                    <NavLink to={Navigation.rightholder.matchClaim.matchHistory(currentRightsholderId)}>
                        Match History
                    </NavLink>
                </ExpandableItem>
            )}
        </>
    )
}

export default MatchingToolSubNavigation
